"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UrlActionEvent {
    constructor(_url, _target) {
        this._url = _url;
        this._target = _target;
    }
    get url() {
        return this._url;
    }
    get target() {
        return this._target;
    }
}
exports.UrlActionEvent = UrlActionEvent;
//# sourceMappingURL=UrlActionEvent.js.map